import {Vehicle} from '../../gql/customer/graphql.ts';
import {VehicleLogo, VehicleLogoSize} from './vehicle_logo.tsx';
import {VehicleBrandModel} from './vehicle_brand_model.tsx';
import {Identifier} from '../identifier/identifier.tsx';
import {Card} from '../card/card.tsx';
import {brandLogo} from '../../support/brand_logo.ts';
interface OwnProps {
    vehicle: Vehicle;
}

export function VehicleCard({vehicle}: OwnProps) {
    return (
        <Card to={`/vehicles/${vehicle.id}`}>
            <VehicleLogo alt={vehicle.brand ?? 'auto'} src={brandLogo(vehicle.brand)} size={VehicleLogoSize.Large} />
            <VehicleBrandModel brand={vehicle.brand ?? ''} model={vehicle.model ?? ''}>
                <Identifier identifier={vehicle.identifiers?.find((id) => id?.type === 'license_plate')?.value ?? ''} />
            </VehicleBrandModel>
        </Card>
    );
}
